import React, { useEffect } from "react"
import Footer from "../Footer/Footer"
import Header from "../Header/Header"
import {GlobalStyles, Root, Primary} from './Layout.styles'

import {GlobalStateContext, GlobalDispatchContext } from "../../../src/context/GlobalContextProvider"


const Layout = ({ children }) => {

    const dispatch = React.useContext(GlobalDispatchContext)
    const state = React.useContext(GlobalStateContext)  

    useEffect(()=>{
        if( window.location.pathname.indexOf('/news') === -1 && 
            window.location.pathname.indexOf('/resources')   === -1 &&
            window.location.pathname.indexOf('/posts')   === -1 &&
            state.searchParams){

            dispatch({type: 'SEARCH_PARAMS', payload: null})
        }   
    })

    return(
        <Root>
            <GlobalStyles/>
            <Header/>
            <Primary className="main-content">{ children }</Primary>
            <Footer/>
        </Root>
    )
}

export default Layout;